import { useMyMonitoringGetControlForEdit } from '@apps-common/apis/my-monitoring/control'
import { useGetUnitControl } from '@apps-common/apis/portal/control'
import { ButtonRoundedSm } from '@apps-common/components/elements'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { FORM_CONTROL_MODIFY_ID } from '@apps-common/config/form'
import { ModalDismiss } from '@apps-common/config/modal'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'
import { invalidateAllControlQueries } from '@apps-common/lib/invalidateControlQueries'
import { useState } from 'react'
import { ControlModifyForm } from '../components'

export interface IScheduleModifyModalProps {
  unitId: string
  controlId?: number
  productId?: string
  isActivated?: boolean
}

export const ControlModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IScheduleModifyModalProps
}) => {
  const { unitId, controlId, productId, isActivated = true } = componentProps
  const [updating, setUpdating] = useState<boolean>(false)
  const useGetControlHook = useProjectHook(useGetUnitControl, useMyMonitoringGetControlForEdit)

  const {
    data: control,
    isLoading: controlIsLoading,
    isRefetching: controlIsRefetching,
    refetch: controlRefetch
  } = useGetControlHook({
    config: {
      enabled: !!controlId,
      refetchOnMount: true
    },
    controlId: controlId || 0
  })

  const onSave = () => {
    invalidateAllControlQueries(unitId, controlId)

    onDismiss(null, ModalDismiss.Confirm)
  }

  const loading = controlId !== undefined && (controlIsLoading || controlIsRefetching)

  return (
    <ModalContainer alwaysMobile>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={!!controlId ? 'Update' : 'Create'} title='Control' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='pt-[90px]'>
        <ControlModifyForm
          unitId={unitId}
          productId={productId}
          isActivated={isActivated}
          loading={loading}
          control={control}
          onSave={onSave}
          onUpdating={setUpdating}
        />
      </ModalBody>
      <ModalFooter>
        <div className='flex items-center justify-between gap-2'>
          <ButtonRoundedSm
            type='submit'
            form={FORM_CONTROL_MODIFY_ID}
            loading={loading || updating}
            text={!!controlId ? 'Update' : 'Create'}
            className='action-success'
          />
          <ButtonRoundedSm
            type='button'
            loading={updating}
            text='Cancel'
            className='action-neutral'
            callback={() => onDismiss(null, ModalDismiss.Cancel)}
          />
        </div>
      </ModalFooter>
    </ModalContainer>
  )
}
